export default __webpack_public_path__ + "static/media/nocheck.4d08d0ba.png";